import { i18nScope, metaKey } from '~/scripts/utils';

export default async ({ route, store }) => {
  store.commit('pageContent/setJumbotron', null);
  const $i18n = store.$i18n;
  if (metaKey(route, 'disableJumbotron')) {
    return store.commit('pageContent/setJumbotron', null);
  }
  const jumbo = {
    list: metaKey(route, 'jumbotronList'),
    tacs: metaKey(route, 'jumbotronTacs')
  };
  jumbo.params = metaKey(route, 'jumbotronParams') || [];
  const scope = ['pageInfo', metaKey(route, 'jumbotronScope') || i18nScope(route, $i18n) || 'index'].join('.');
  const title = metaKey(route, 'jumbotronTitle') || metaKey(route, 'title') || $i18n.t(`${scope}.title`, jumbo.params);
  if (title) {
    jumbo.title = title;
  }
  if (metaKey(route, 'providerDescriptionAsJumbotronSubtitle')) {
    const provider = store.getters['providers/get'];
    jumbo.subtitle = provider.description;
  }
  Object.keys($i18n.t(`${scope}.jumbotron`)).forEach(key => {
    const scopeKey = `${scope}.jumbotron.${key}`;
    if (typeof $i18n.t(scopeKey) === 'object' && key === 'subtitle') {
      jumbo['subtitleList'] = Object.keys($i18n.t(scopeKey)).map(index => $i18n.t(`${scopeKey}.${index}`, jumbo.params));
    } else {
      jumbo[`${key}Key`] = scopeKey;
      jumbo[key] = $i18n.t(scopeKey, jumbo.params);
    }
  });
  store.commit('pageContent/setJumbotron', jumbo);
};
